<p-dialog
    header="Suppression de participant"
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="custom-edit-member-role-modal"
    appendTo="body"
>
    <div>
        <p>Vous allez retirer ce membre de cette projet</p>
    </div>
    <p-footer>
        <button
            pButton
            type="button"
            class="p-button-text p-button p-button-sm p-button-custom-cancel"
            label="{{ 'components.button.buttonCancel' | translate }}"
            (click)="toggleRemoveUserModal(null)"
        ></button>

        <button
            pButton
            class="p-button p-button-sm p-button-custom-submit"
            type="button"
            label="{{ 'components.button.buttonConfirm' | translate }}"
            (click)="removeAttendeeFromProject(userToUpdate)"
        ></button>
    </p-footer>
</p-dialog>
